
import { defineComponent, reactive, toRefs } from 'vue'
import { ElMessage } from 'element-plus'
import { controlModeEnum } from '../config'
import { setControlMode } from '../api'

export default defineComponent({
  name: 'set-control-dialog', // 设定管控弹窗
  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    ids: {
      type: Array,
      default: () => []
    }
  },
  emits: ['update:modelValue', 'refreshList'],
  setup(props, { emit }) {
    const data = reactive({
      visible: props.modelValue,
      controlMode: null as number | null
    })

    // 关闭弹窗并重置
    const handleCloseDialog = () => {
      data.controlMode = null
      emit('update:modelValue', false)
    }

    // 提交设定
    const submitDialog = () => {
      if (!data.controlMode) {
        ElMessage.warning('请选择管控模式')
        return
      }
      setControlMode({
        ids: props.ids,
        controlMode: data.controlMode
      }).then((res: any) => {
        ElMessage.success(res.msg)
        handleCloseDialog()
        emit('refreshList')
      })
    }

    return {
      controlModeEnum,
      ...toRefs(data),
      handleCloseDialog,
      submitDialog
    }
  }
})
